import { useEffect, useState } from "react";

export function usePhotoMetadata(url) {
  const [meta, setMeta] = useState({
    type: null,
    size: null,       // number (байты) или null
    width: null,
    height: null,
  });

  useEffect(() => {
    if (!url) return;
    let cancelled = false;

    (async () => {
      try {
        // 1) Габариты изображения
        let width = null, height = null;
        try {
          await new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => {
              width = img.naturalWidth || null;
              height = img.naturalHeight || null;
              resolve();
            };
            img.onerror = reject;
            img.referrerPolicy = "no-referrer";
            img.src = url;
          });
        } catch (_e) {}

        let size = null;
        let type = null;

        // 2) HEAD → Content-Length / Content-Type
        try {
          const res = await fetch(url, { method: "HEAD" });
          type = res.headers.get("Content-Type") || type;
          const len = res.headers.get("Content-Length");
          if (len && /^\d+$/.test(len)) size = Number(len);
        } catch (_e) {}

        // 3) GET с Range → Content-Range: bytes 0-0/TOTAL
        if (!size) {
          try {
            const res = await fetch(url, {
              method: "GET",
              headers: { Range: "bytes=0-0" },
            });
            type = res.headers.get("Content-Type") || type;
            const cr = res.headers.get("Content-Range"); // "bytes 0-0/12345"
            if (cr && /\/\d+$/.test(cr)) {
              const total = parseInt(cr.split("/").pop(), 10);
              if (!Number.isNaN(total)) size = total;
            }
          } catch (_e) {}
        }

        // 4) Фолбэк: полный GET → blob.size
        if (!size) {
          try {
            const res = await fetch(url, { cache: "no-store" });
            const blob = await res.blob();
            size = blob.size;
            type = type || blob.type || null;
          } catch (_e) {}
        }

        if (!cancelled) {
          setMeta({
            type: type ? type.split(";")[0] : null,
            size: size ?? null,
            width,
            height,
          });
        }
      } catch (_e) {
        if (!cancelled) {
          setMeta({ type: null, size: null, width: null, height: null });
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [url]);

  return meta;
}
